import axios from 'axios';

/**
 * Fetch user's crypto balances from the database
 * These are tracked app balances (available amount, total deposited, etc.)
 */
export const getCryptoBalancesApi = async (): Promise<
  CryptoBalanceWithWallet[]
> => {
  const response = await axios.get<{
    balances: CryptoBalanceWithWallet[];
  }>('/api/crypto/balance');
  return response.data.balances;
};

/**
 * Fetch user's crypto balance statistics
 */
export const getCryptoBalanceStatsApi =
  async (): Promise<CryptoBalanceStats> => {
    const response = await axios.get<{
      stats: CryptoBalanceStats;
    }>('/api/crypto/balance?view=stats');
    return response.data.stats;
  };
